import React, {useContext, useEffect, useState} from "react";
import {Menu, type MenuProps, theme} from "antd";
import Sider from "antd/es/layout/Sider";
import {RiBardLine, RiFileSearchLine} from "react-icons/ri";
import {TiDocumentText} from "react-icons/ti";
import {FiSend} from "react-icons/fi";
import {AuthContext} from "../../../../config/AuthContext";

interface Props {
    setPantalla: (value: number) => void;
}

const AppSiderProblemesIdExamen = (props: Props) => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const [pantalla, setPantalla] = useState(0);

    useEffect(() => {
        document.title = 'Web Dubtes';
    }, []);

    const titles: string[] = ['Enunciat'];
    const titlesProfes: string[] = ['Enunciat', 'Enviaments', 'Alumnes'];

    const items: MenuProps['items'] = [TiDocumentText].map(
        (icon, index) => {
            const key = String(index + 1);

            return {
                key: key,
                icon: React.createElement(icon),
                label: titles[index],
                onClick: () => (setPantalla(index), props.setPantalla(index))
            };
        },
    );
    const itemsProfes: MenuProps['items'] = [TiDocumentText, FiSend, RiFileSearchLine].map(
        (icon, index) => {
            const key = String(index + 1);

            return {
                key: key,
                icon: React.createElement(icon),
                label: titlesProfes[index],
                onClick: () => (setPantalla(index), props.setPantalla(index))
            };
        },
    );

    const {
        token: {colorBgContainer, borderRadiusLG},
    } = theme.useToken();

    return (
        <Sider style={{background: colorBgContainer}} width={200}>
            <Menu
                mode="inline"
                defaultSelectedKeys={[(pantalla + 1) + ""]}
                defaultOpenKeys={['sub1']}
                style={{height: '100%'}}
                items={user.tipus === "0" || user.tipus === "1" ? itemsProfes : items}
            />
        </Sider>
    );
}

export default AppSiderProblemesIdExamen;